import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteAgency } from '../../api/apiAgencies';
import toast from 'react-hot-toast';

export const useDeleteAgency = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteAgency,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['agencies'] });
            toast.success(data.message || 'Agency deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to delete agency';
            toast.error(errorMessage);
        },
    });
};
